/*============ Account Migration Page Controller
 ================================*/
angular
    .module('vppApp')
    .controller('accountMigrationStep2Controller', accountMigrationStep2Controller);

accountMigrationStep2Controller.$inject = ['$window', '$scope', '$rootScope', '$location', 'vppConfig', 'apiFactory', '$state', '$http', 'AuthenticationService', 'DTMTrackerService', '$stateParams', '$cookies', 'CreateAccountService', 'ThirdPartyMessages'];

function accountMigrationStep2Controller($window, $scope, $rootScope, $location, vppConfig, apiFactory, $state, $http, AuthenticationService, DTMTrackerService, $stateParams, $cookies, CreateAccountService, ThirdPartyMessages) {
    
    $scope.siteCode = vppConfig.folderPath;
    $scope.isEMP = vppConfig.folderPath === "emp" ? true : false;
    $scope.skipNameValidation = true;
    $scope.nicknameSelection = "default";

    $scope.userAccountMigrationDetails = CreateAccountService.getAccountMigrationDetails();

    $scope.user = {
          password: "",
          firstName: "",
          lastName: "",
          siteCode: $scope.siteCode,
          accountId: $scope.userAccountMigrationDetails.accountId,
          language: "english"
    }

    apiFactory.getSsoUrl().then(function (response) {
        $scope.ssoUrl = response.data;
    });

    // API call to check status using input
    // This can be removed
    $scope.submitAccountMigrationStep2 = function (user) {
        $scope.responsePending = true;

        if ($scope.nicknameSelection === 'default' && $scope.isEMP) {
            user.firstName = $scope.userAccountMigrationDetails.firstName;
            user.lastName = $scope.userAccountMigrationDetails.lastName;
        }

        apiFactory.postMigratedUserRegistration(user).then(function(response){
            $scope.responsePending = false;
            ThirdPartyMessages.setMessage('registerNoAccount', '');
            $state.go('index');
            }, function errorCallBack(response) {
            $scope.responsePending = false;
            $scope.serverError = response.data.errors;
        });
    }

    $scope.checkPreferredNameSelection = function(nicknameSelection){

        if(nicknameSelection === 'nickname'){
          $scope.skipNameValidation = false;
        } else {
          $scope.skipNameValidation = true;
        }
      }
};
